import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { pushGtmPageView } from "@/analytics/googleTagManager";
import { shouldTrackAnalytics } from "@/analytics/tracking";

/**
 * SPA route changes: GTM records the first page view on initial load.
 */
export default function GoogleTagManager() {
  const { pathname, search } = useLocation();
  const skipNextPageView = useRef(true);

  useEffect(() => {
    if (!shouldTrackAnalytics(pathname)) return;

    if (skipNextPageView.current) {
      skipNextPageView.current = false;
      return;
    }

    pushGtmPageView(pathname, search);
  }, [pathname, search]);

  return null;
}
